import styled from "styled-components";

export const Input = styled.input`
  width: 100%;
  height: 48px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.light?.border || theme.colors.border};
  padding: 0 16px;
  font-size: 16px;
  outline: none;
  background: ${({ theme }) => theme.colors.light?.background || theme.colors.landing?.background?.primary || "white"};
  color: ${({ theme }) => theme.colors.light?.foreground || theme.colors.text.body};
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: ${({ theme }) => theme.colors.light?.primary || theme.colors.primary.light};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.light?.primary || theme.colors.primary.light}20;
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.light?.muted?.foreground || theme.colors.text.muted};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 16px; /* Prevents zoom on iOS */
  }
`;

